import React, { useEffect, useState } from 'react'
import CreateEventCard from '../EventsPage/CreateEventCard'
import { useNavigate } from 'react-router'
import { t } from 'i18next'
import { get } from '../../Common/api'
import { Color } from '../../Common/Color'

const UnresolvedEvent = ({ events }) => {
  const navigate = useNavigate()

  const Content = ({ events }) => {
    return events.map(event => (
      <li key={event.id} className='hoverable' style={{ cursor: 'pointer', '--hover-color': Color.red, fontSize: '0.8em' }}
        onClick={() => navigate(`/admin/events/${event.id}`)} >
        {event.title}
      </li>
    ))
  }
  return (
    <>
      <div style={{ fontWeight: 'bold', textAlign: 'center', margin: '1em' }}>
        {t('Admin.Event.list')}
      </div>
      <ul style={{ padding: '1em' }}>
        <Content events={events} />
      </ul>
    </>
  )
}

export default function EventsTab ({ slot, setLoading, style = {} }) {
  const [events, setEvents] = useState([])

  const getEvents = async () => {
    setLoading(true)
    await get('admin/events', { box_id: slot.box_id, slot_id: slot.id }, (res) => {
      setLoading(false)
      setEvents(res.events)
    }, () => {
      setLoading(false)
    })
  }

  useEffect(() => {
    getEvents()
  }, [])

  return (
    <div style={{ ...style }} >
      <div style={{ margin: '0 30%' }}><CreateEventCard box={slot.box} slot={slot} setLoading={setLoading} /></div>
      <UnresolvedEvent events={events} />
    </div>
  )
}
